module.exports = __webpack_public_path__ + "static/media/safira.12d4ada1.webp";